interface IProps {
  value: number | string;
  name: string;
  className: string;
  active?: boolean;
}

const LabelComponent = (props: IProps): string => {
  const active = props.active === true ? 'active' : '';
  return `
        <div class="${props.className} card card-link pointer label m-2 ${active}" data-value=${props.value}>
            <div class="card-body label-body d-flex">
                <img class='label-img d-block' src='https://images.unsplash.com/photo-1593642634443-44adaa06623a?ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=925&q=80' alt=''>
                <span class="label-text d-block pt-2">${props.name}</span>
            </div>
        </div>
  `;
};
export default LabelComponent;
